import { render, staticRenderFns } from "./Reservas.vue?vue&type=template&id=ac0cf79e"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"
import style0 from "./Reservas.vue?vue&type=style&index=0&id=ac0cf79e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports